import {
  Login,
  ForgetPassword,
  SetPassword,
  Dashboard,
  UserManagement,
  Reports,
  Cart,
  Product,
  Purchases,
  Receipt,
  JobOffer,
  JobApplication,
} from '@src/pages';
import Transaction from '../pages/Transaction';

export const publicRoutes = {
  login: '/auth/login',
  forgetPassword: '/auth/forget-password',
  setPassword: '/auth/set-password',
};

export const privateRoutes = {
  dashboard: '/panel/admin/dashboard',
  userManagement: '/panel/admin/user-management',
  reports: '/panel/admin/reports',
  news: '/panel/admin/news',
  cart: '/panel/admin/cart',
  product: '/panel/admin/product',
  purchases: '/panel/admin/purchases',
  jobOffer: '/panel/admin/job-offer',
  jobApplication: '/panel/admin/job-application',
  receipt: '/panel/receipt',
  transaction: '/panel/admin/transaction',
};

export const publicRouteList = Object.values(publicRoutes);
export const privateRouteList = Object.values(privateRoutes);

export const neverShowLayout = [
  '/',
  publicRoutes.login,
  publicRoutes.forgetPassword,
  publicRoutes.setPassword,
];
export const routesMapping = [
  {
    route: publicRoutes.login,
    Element: <Login />,
  },
  {
    route: publicRoutes.forgetPassword,
    Element: <ForgetPassword />,
  },
  {
    route: publicRoutes.setPassword,
    Element: <SetPassword />,
  },
  {
    route: privateRoutes.dashboard,
    Element: <Dashboard />,
  },
  {
    route: privateRoutes.userManagement,
    Element: <UserManagement />,
  },
  {
    route: privateRoutes.reports,
    Element: <Reports />,
  },
  {
    route: privateRoutes.cart,
    Element: <Cart />,
  },
  {
    route: privateRoutes.product,
    Element: <Product />,
  },
  {
    route: privateRoutes.purchases,
    Element: <Purchases />,
  },
  {
    route: privateRoutes.receipt,
    Element: <Receipt />,
  },
  {
    route: privateRoutes.transaction,
    Element: <Transaction />,
  },
  {
    route: privateRoutes.jobOffer,
    Element: <JobOffer />,
  },
  {
    route: privateRoutes.jobApplication,
    Element: <JobApplication />,
  },
];

const alwaysShowRoutes = ['/', '/test'];

export const filterRoutesByAuthStep = (isAuth) => {
  return routesMapping.filter((item) => {
    if (!isAuth) {
      if (publicRouteList.includes(item.route) || alwaysShowRoutes.includes(item.route)) {
        return item;
      }
    } else if (!publicRouteList.includes(item.route) || alwaysShowRoutes.includes(item.route)) {
      return item;
    }
  });
};
